import React, { useMemo } from "react";
import { Box } from "@mui/material";

import CurrencyFormat from 'react-currency-format';

function CurrencyFormatter(props) {
    const value = useMemo(() =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currencySign: 'accounting',
            currency: 'USD'
        }).format(props.value), [props.value]);

    return <Box component="span" sx={{ color: props.color ? props.color : props.value < 0 ? "red" : "black" }} >{value}</Box>
    // return <CurrencyFormat value={props.value} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={"2"} fixedDecimalScale={true} format={(value) => { console.log(value); return 0;}} />
}

export default CurrencyFormatter;